export default __webpack_public_path__ + "static/media/amzn-token.2cc115b9.png";